import {asyncRouterMap, constantRouterMap} from "../../router";
import store from '../index';
import Cookies from 'js-cookie'
import { getToken, setToken, removeToken } from '@/utils/auth'
import {isEmpty} from '@/utils'

const permission = {
  state: {
    routers: constantRouterMap,
    loadRouter:false,
    addRouters: [],
    pathAccess: [],
    subjectData: JSON.parse(localStorage.getItem("subjectData")) || [],
    questBankData: JSON.parse(localStorage.getItem("bankQuest")) || {
      gross_score:100,
      // is_hidden:0,
      is_reload:1
    },
    questionnaireTopic:'',
    tabVal: localStorage.getItem("tabVal") || '0'
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers)
    },
    SET_ACCESS: (state, pathAccess) => {
      state.pathAccess = pathAccess
    },
    SET_LOADROUTERS:(state, status) => {
      state.loadRouter = status;
    },
    SET_SUBJECTDATA:(state, data) => {
      if(state.subjectData.length > 0){
        //  当前题库所有选中的数据
        var arr = []
        for(var i=0; i<state.subjectData.length; i++) {
          if(state.subjectData[i].library_id == data[0].library_id && state.subjectData[i].is_hidden == '0'){
            arr.push(state.subjectData[i])
          }
        }
        //  当前题库取消选中的数据
        for(var i=0; i<data.length; i++){
          for(var j=0; j<arr.length; j++){
            if(data[i].library_id == arr[j].library_id && data[i].topic_id == arr[j].topic_id){
              arr.splice(j,1)
              j--;
            }
          }
        }
        //  删除存储中取消选中的数据
        for(var i=0; i<arr.length; i++){
          for(var j=0; j<state.subjectData.length; j++) {
            if(state.subjectData[j].library_id == arr[i].library_id && state.subjectData[j].topic_id == arr[i].topic_id){
              state.subjectData.splice(j,1)
              j--;
            }
          }
        }
        //  删除传过来的和存储相同的数据
        for(var i=0; i<state.subjectData.length; i++){
          for(var j=0; j<data.length; j++){
            if(state.subjectData[i].library_id == data[j].library_id && state.subjectData[i].topic_id == data[j].topic_id){
              data.splice(j,1)
              j--;
            }
          }
        }
        //  将最后传过来的数据放进存储数据里面
        data.forEach((item)=>{
          state.subjectData.push(item)
        })
      }else{
        state.subjectData = data
      }
      localStorage.setItem("subjectData",JSON.stringify(state.subjectData))
    },
    CLEAR_SUBJECTDATA:(state, data) => {
      for(var i=0; i<state.subjectData.length; i++){
        if(state.subjectData[i].library_id == data && state.subjectData[i].is_hidden == '0'){
          state.subjectData.splice(i,1)
          i--;
        }
      }
      localStorage.setItem("subjectData",JSON.stringify(state.subjectData))
    },
    DEL_SUBJECTDATA:(state, data) => {
      state.subjectData.forEach((item,index)=>{
        if(item.id == data.id){
          state.subjectData.splice(index,1)
        }
      })
      localStorage.setItem("subjectData",JSON.stringify(state.subjectData))
    },
    CLEAR_SUBJECT:(state, data) => {
      state.subjectData = data
      localStorage.setItem("subjectData",JSON.stringify(state.subjectData))
    },
    SET_QUESTBANKDATA:(state, data) => {
      state.questBankData = data
      localStorage.setItem("bankQuest",JSON.stringify(state.questBankData))
    },
    SET_TABVAL:(state, data) => {
      state.tabVal = data
      localStorage.setItem("tabVal",state.tabVal)
    },
    // 题库选择问卷存值
    CHOOSE_QUESTIONNAIRE:(state,data) => {
      console.log(data)
    }
  },
  actions: {
    GenerateRoutes({ commit }) {
     let departRoles =  Cookies.get('departRoles');
     departRoles = JSON.parse(departRoles);
     if (!isEmpty(departRoles)){
       let result = departRoles.some(function (item) {
         return (item.role_id == 1 || item.role_id == 2)
       })
       if (result) {
         commit('SET_ROUTERS', asyncRouterMap)
       }
     }
      commit('SET_LOADROUTERS',true);
    },
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        removeToken();
        resolve()
      })
    },
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js